import script from "./ViewLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLinks.vue?vue&type=script&setup=true&lang=js"

import "./ViewLinks.vue?vue&type=style&index=0&id=f65695ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65695ac"]])

export default __exports__